import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
// import { get } from "lodash";
import router from "@/router";
import { API_URL } from "./config";
const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
        axios.interceptors.response.use(
            response => {
                return response;
            },
            function(error) {
                if (error.response && 500 === error.response.status) {
                  router.push('/500');
                }else if(error.response && 404 === error.response.status){
                  router.push('/404');
                }
                // Do something with response error
                return Promise.reject(error.response);
            }
        );
    },

    setHeader() {},

    query(resource, params) {
        return Vue.axios.get(resource, params).catch(error => {
            throw new Error(`ApiService ${error}`);
        });
    },

    get(resource, slug = "") {
        let url = `${resource}`;
        if (slug) {
            url = `${resource}/${slug}`;
        }
        return Vue.axios.get(url).catch(error => {
            throw new Error(`ApiService ${error}`);
        });
    },

    post(resource, params, config = {}) {
        return Vue.axios.post(`${resource}`, params, config);
    },

    update(resource, slug = "", params) {
        let url = `${resource}`;
        if (slug) {
            url = `${resource}/${slug}`;
        }
        return Vue.axios.put(url, params);
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },

    delete(resource) {
        return Vue.axios.delete(resource).catch(error => {
            throw new Error(`ApiService ${error}`);
        });
    }
};

export default ApiService;

// products
export const ProductsService = {
    getProducts() {
        return ApiService.get(`products`);
    }
};
//
